import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutHalfFull: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-half-full"><path d="M20.25 3.75H21V3H20.25V3.75ZM20.25 20.25V21H21V20.25H20.25ZM3.75 20.25H3V21H3.75V20.25ZM3.75 3.75V3H3V3.75H3.75ZM19.5 3.75V20.25H21V3.75H19.5ZM20.25 19.5H3.75V21H20.25V19.5ZM4.5 20.25V3.75H3V20.25H4.5ZM3.75 4.5H20.25V3H3.75V4.5Z" fill="currentColor"/><path d="M20.25 12.75H21V11.25H20.25V12.75ZM3.75 11.25H3V12.75H3.75V11.25ZM3.75 12.75H20.25V11.25H3.75V12.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLayoutHalfFull;
